const nameEntity = 'ContractUpdate'
const nameSource = 'commercial/contractsUpdates'
const namePageTitle = 'Alterações de contrato'

export { nameEntity, nameSource, namePageTitle }
